import { render, staticRenderFns } from "./HeaderInfo.vue?vue&type=template&id=b88f7926&scoped=true"
import script from "./HeaderInfo.vue?vue&type=script&lang=js"
export * from "./HeaderInfo.vue?vue&type=script&lang=js"
import style0 from "./HeaderInfo.vue?vue&type=style&index=0&id=b88f7926&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b88f7926",
  null
  
)

export default component.exports